module.exports = __webpack_public_path__ + "static/media/10_minutes.02c07002.svg";